
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { bindActionCreators } from "redux";
import Form from "../../components/forms/InspectionForm";
import { breadcrumbs } from "../../../../actions/appActions";
import { updateInspectionResult, deleteInspectionResult, withRedirectBack } from "../../CroActions";

const selector = formValueSelector("inspectionForm");

const mapStateToProps = (state, { params, auth }) => ({
  breadcrumbsItems: [{ label: "Kontrola" }],
  url: `${auth.startUrl}/api/funkcionari/${params.id}/kontroly/${params.inspection_id}`,
  result: selector(state, 'result'),
  type: selector(state, 'type'),
  forwardedTo: selector(state, 'forwardedTo'),
  officialId: params.id,
  auth: auth
});

const onSubmit = (auth, officialId, inspectionId) => {
  return withRedirectBack(updateInspectionResult(auth.startUrl, officialId, inspectionId));
};

const onDelete = (auth, officialId, inspectionId) => {
  return withRedirectBack(deleteInspectionResult(auth.startUrl, officialId, inspectionId));
}

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators({
    onSubmit: onSubmit(props.auth, props.params.id, props.params.inspection_id),
    breadcrumbs }, dispatch),
  onDelete: () => {
    dispatch(onDelete(props.auth, props.params.id, props.params.inspection_id)())
  },
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
